import HelpTooltip from 'components/tooltip/HelpTooltip'
import Table from 'components/table/Table'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { dateformat } from 'utils'
import Moment from 'react-moment'
import Icon from 'components/Icon'
import FixedTable from 'components/table/FixedTable'
import { Fragment } from 'react'

const PLUSFRIEND_SERVICE_NAMES = {
  alimtalk: '이벤트/태그 설정됨',
  sync: '싱크',
}
const { REACT_APP_BUSINESS_HOST } = process.env
const Services = () => {
  const { content, isLoading } = useSelector(
    state => state.tracker.detail.services
  )
  const { trackId } = useParams()
  return (
    <div className="audience_detail">
      <div className="tbl_top">
        <p className="txt_noti">
          카카오 서비스를 연동하거나 웹사이트와 앱에 픽셀 & SDK를 설치하면
          이벤트를 수집할 수 있습니다.
        </p>
      </div>
      <div className="tblg2_wrap">
        <FixedTable
          caption="연동 서비스 정보"
          loading={isLoading}
          emptyMessage={
            <>
              연동 중인 서비스가 없습니다.
              <br />
              <a
                href={`${REACT_APP_BUSINESS_HOST}/pixel/detail/${trackId}`}
                className="link_txt"
                target="_blank"
                rel="noopener noreferrer">
                픽셀 &amp; SDK 관리
              </a>{' '}
              페이지에서 연동이 가능합니다.
            </>
          }>
          <Table.Head>
            <Table.Column title="연동 일시" width={172} />
            <Table.Column title="구분" width={144} />
            <Table.Column
              title={
                <>
                  서비스
                  <HelpTooltip>
                    웹사이트/앱, 알림톡/싱크에서 이벤트가 발생하면 그 다음날부터
                    목록에 표시되며,
                    <br />
                    7일간 이벤트가 발생하지 않으면 목록에 표시되지 않습니다.
                  </HelpTooltip>
                </>
              }
            />
          </Table.Head>
          <Table.Body>
            {content.map(
              ({
                createdAt,
                service,
                serviceName,
                targetKey,
                targetKeyDesc,
                targetKeyUrl,
                trackLinkedServices = [],
              }) => (
                <Fragment key={targetKey}>
                  <Table.Row key={targetKey} rowId={targetKey}>
                    <td>
                      <div className="inner_tbl">
                        <Moment format={dateformat}>{createdAt}</Moment>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">{serviceName}</div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {targetKeyUrl ? (
                          <a
                            href={
                              /^(http|https):\/\//.test(targetKeyUrl)
                                ? targetKeyUrl
                                : `https://${targetKeyUrl}`
                            }
                            className="link_txt"
                            target="_blank"
                            rel="noopener noreferrer">
                            {targetKeyDesc}
                          </a>
                        ) : (
                          targetKeyDesc
                        )}
                      </div>
                    </td>
                  </Table.Row>
                  {service === 'plusfriend' &&
                    trackLinkedServices.length > 0 &&
                    trackLinkedServices.map(linkedService => (
                      <Table.Row
                        key={`${linkedService.service}_${targetKey}`}
                        rowId={`${linkedService.service}_${targetKey}`}
                        className="tr_depthitem">
                        <td>
                          <div className="inner_tbl">
                            <Moment format={dateformat}>
                              {linkedService.createdAt}
                            </Moment>
                          </div>
                        </td>
                        <td>
                          <div className="inner_tbl">{serviceName}</div>
                        </td>
                        <td>
                          <div className="inner_tbl">
                            <Icon name="depth" />{' '}
                            {PLUSFRIEND_SERVICE_NAMES[linkedService.service] ||
                              linkedService.serviceName}
                          </div>
                        </td>
                      </Table.Row>
                    ))}
                </Fragment>
              )
            )}
          </Table.Body>
        </FixedTable>
      </div>
    </div>
  )
}
export default Services
